/* eslint-disable no-undef, no-unused-vars, no-case-declarations, no-async-promise-executor */

const c = (a, t) => {
  const i = 2 * Math.PI * t * a;
  return i / (i + 1);
}, h = (a, t, i) => a * t + (1 - a) * i;
class y {
  constructor({ minCutOff: t, beta: i }) {
    this.minCutOff = t, this.beta = i, this.dCutOff = 1e-3, this.xPrev = null, this.dxPrev = null, this.tPrev = null, this.initialized = !1;
  }
  reset() {
    this.initialized = !1;
  }
  filter(t, i) {
    if (!this.initialized)
      return this.initialized = !0, this.xPrev = i, this.dxPrev = i.map(() => 0), this.tPrev = t, i;
    const { xPrev: e, tPrev: r, dxPrev: p } = this, s = t - r, m = c(s, this.dCutOff), l = [], o = [], d = [];
    for (let n = 0; n < i.length; n++) {
      l[n] = (i[n] - e[n]) / s, o[n] = h(m, l[n], p[n]);
      const g = this.minCutOff + this.beta * Math.abs(o[n]), f = c(s, g);
      d[n] = h(f, i[n], e[n]);
    }
    return this.xPrev = d, this.dxPrev = o, this.tPrev = t, d;
  }
}
const u = `<div class="mindar-ui-overlay mindar-ui-loading">\r
  <div class="loader"/>\r
</div>\r
`, v = `<div class="mindar-ui-overlay mindar-ui-compatibility">\r
  <div class="content">\r
    <h1>Failed to launch :(</h1>\r
    <p>\r
      Looks like your device/browser is not compatible.\r
    </p>\r
\r
    <br/>\r
    <br/>\r
    <p>\r
      Please try the following recommended browsers:\r
    </p>\r
    <p>\r
      For Android device - Chrome\r
    </p>\r
    <p>\r
      For iOS device - Safari\r
    </p>\r
  </div>\r
</div>\r
`, x = `<div class="mindar-ui-overlay mindar-ui-scanning">\r
  <div class="scanning">\r
    <div class="inner">\r
      <div class="scanline"/>\r
    </div>\r
  </div>\r
  <div class="tip"><span>请将摄像机对准单个产品进行扫描</span></div>\r
</div>\r
`, b = ".mindar-ui-overlay{display:flex;align-items:center;justify-content:center;position:absolute;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,0);z-index:2}.mindar-ui-overlay.hidden{display:none}.mindar-ui-loading .loader{border:16px solid #222;border-top:16px solid #fff;opacity:.8;border-radius:50%;width:120px;height:120px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.mindar-ui-compatibility .content{background:#000;color:#fff;opacity:.8;text-align:center;margin:20px;padding:20px;min-height:50vh}@media(min-aspect-ratio: 1){.mindar-ui-scanning .scanning{width:50vh;height:50vh}}@media(max-aspect-ratio: 1){.mindar-ui-scanning .scanning{width:80vw;height:80vw}}.mindar-ui-scanning .scanning .inner{position:relative;width:100%;height:100%;opacity:.8;background:linear-gradient(to right, white 10px, transparent 10px) 0 0,linear-gradient(to right, white 10px, transparent 10px) 0 100%,linear-gradient(to left, white 10px, transparent 10px) 100% 0,linear-gradient(to left, white 10px, transparent 10px) 100% 100%,linear-gradient(to bottom, white 10px, transparent 10px) 0 0,linear-gradient(to bottom, white 10px, transparent 10px) 100% 0,linear-gradient(to top, white 10px, transparent 10px) 0 100%,linear-gradient(to top, white 10px, transparent 10px) 100% 100%;background-repeat:no-repeat;background-size:40px 40px}.mindar-ui-scanning .scanning .inner .scanline{position:absolute;width:100%;height:10px;background:#fff;animation:move 2s linear infinite}@keyframes move{0%,100%{top:0%}50%{top:calc(100% - 10px)}}.mindar-ui-scanning .tip{position:absolute;left:50%;top:10vh;transform:translateX(-50%);font-size:14px;font-weight:500;letter-spacing:1px;text-shadow:0px 0px 6px rgba(0,0,0,.6);color:#fff;z-index:400;width:100%;display:flex;justify-content:center;align-items:center}@media(max-aspect-ratio: 1){.mindar-ui-scanning .tip{top:10vh}}@media(min-aspect-ratio: 1){.mindar-ui-scanning .tip{top:5vh}}/*# sourceMappingURL=a.css.map */";
class M {
  constructor({ uiLoading: t, uiScanning: i, uiError: e }) {
    const r = document.createElement("style");
    r.innerText = b, document.head.appendChild(r), t === "yes" ? this.loadingModal = this._loadHTML(u) : t !== "no" && (this.loadingModal = document.querySelector(t)), e === "yes" ? this.compatibilityModal = this._loadHTML(v) : e !== "no" && (this.compatibilityModal = document.querySelector(e)), i === "yes" ? this.scanningMask = this._loadHTML(x) : i !== "no" && (this.scanningMask = document.querySelector(i)), this.hideLoading(), this.hideCompatibility(), this.hideScanning();
  }
  showLoading() {
    this.loadingModal && this.loadingModal.classList.remove("hidden");
  }
  hideLoading() {
    this.loadingModal && this.loadingModal.classList.add("hidden");
  }
  showCompatibility() {
    this.compatibilityModal && this.compatibilityModal.classList.remove("hidden");
  }
  hideCompatibility() {
    this.compatibilityModal && this.compatibilityModal.classList.add("hidden");
  }
  showScanning() {
    this.scanningMask && this.scanningMask.classList.remove("hidden");
  }
  hideScanning() {
    this.scanningMask && this.scanningMask.classList.add("hidden");
  }
  _loadHTML(t) {
    const i = document.createElement("template");
    i.innerHTML = t.trim();
    const e = i.content.firstChild;
    return document.getElementsByTagName("body")[0].appendChild(e), e;
  }
}
export {
  y as O,
  M as U
};
